// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36xXd","colMin":"styles_colMin__3AQQ6"};